import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { BasicError } from '../error/basic-error';
import { ToastItem } from '../components/shared/toast/item/toast-item.model';
import { LoggerService } from '../services/infrastructure/logger/logger.service';
import { EErrorType } from '../enum/error/error-type.enum';
import { IToastService, IToastServiceToken } from 'shared/services/ui/toast/toast-service.interface';

@Injectable({ providedIn: 'root' })
export class BasicErrorHandler implements ErrorHandler {
  private logger: LoggerService;
  private readonly toastService: IToastService = inject(IToastServiceToken);

  constructor(injector: Injector) {
    this.logger = injector.get(LoggerService);
  }

  handleError(error: any) {
    let nestedError = error?.rejection || error;

    if (nestedError instanceof BasicError) {
      this.handleBasicError(nestedError);
    }
  }

  private handleBasicError(error: BasicError) {
    let consoleString = this.messageCodeCombinationGet(error);

    switch (error.type) {

      case EErrorType.Basic:
        this.displayToast(error, $localize`:@@BasicErrorToastTitle:Error`);
        this.logger.error(consoleString, this.constructor.name);
        break;

      case EErrorType.Authentication:
        this.displayToast(error, $localize`:@@AuthenticationErrorToastTitle:Authentication Error`);
        this.logger.error(consoleString, this.constructor.name);
        break;

      default:
        throw new Error(`Missing implementation of BasicError Handler of type ${error.type}`);
    }
  }

  private displayToast(error: BasicError, title?: string | undefined) {
    if (error.toastType != undefined) {
      this.toastService.toastItemAdd(new ToastItem({
        type: error.toastType,
        code: error.code,
        message: error.message,
        title: title
      }));
    }
  }

  private messageCodeCombinationGet(error: BasicError) {
    return [error.message, error.code].join(' - ');
  }

}
